<template>
  <!-- eslint-disable max-len -->
  <el-dialog
    :title="item.ID ? '编辑发布版本' : '发布新版本'"
    :visible="visible"
    @close="onClose"
    @open="onOpen"
    append-to-body
    :close-on-click-modal="false"
    width="55%"
    top="3vh"
    @beforeopen="onOpen"
  >
    <el-form :model="item" ref="itemform" label-width="150px" :rules="rules">
      <el-row>
        <el-col :span="12">
          <el-form-item label="版本号" prop="Version">
            <el-input
              v-model.trim="item.Version"
              placeholder="请输入版本号"
              :disabled="isEdit"
              maxlength="50"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="发布日期" prop="PublishDay">
            <el-date-picker
              style="display: block; width: 100%"
              v-model="item.PublishDay"
              type="date"
              :picker-options="pickerOptions"
              placeholder="选择日期时间"
              :disabled="isEdit"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item :label="`包含功能版本 ${index+1}`" required
          v-for="(obj, index) in item.VersionFunctions"
          :key="index"
          v-if="isShow">
        <el-row>
          <el-col :span="8">
            <el-form-item :prop="'VersionFunctions.' + index + '.Name'" :rules="rules.FunctionName">
              <el-input
                v-model="obj.Name"
                placeholder="请填写功能版本名称"
                @input="change($event)"
                maxlength="10"
                :disabled="isEdit" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item :prop="'VersionFunctions.' + index + '.SpeNb'" :rules="rules.FunctionCode" style="margin-left:10px">
              <el-input
                v-model="obj.SpeNb"
                placeholder="请填写功能版本编码"
                @input="change($event)"
                maxlength="2"
                :disabled="isEdit" />
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <i
                v-if="index === item.VersionFunctions.length - 1 && !isEdit"
                class="fa fa-plus-circle cur-pointer"
                style="
                  font-size: 18px;
                  position: relative;
                  top: 1px;
                  color: #86c042;
                  margin-left:10px;
                "
                @click="addFunction()"
              ></i>
              <i
                v-if="item.VersionFunctions.length > 1 && !isEdit"
                class="fa fa-minus-circle mar-lft cur-pointer"
                style="
                  font-size: 18px;
                  position: relative;
                  top: 1px;
                  color: #ee4a47;
                  padding-left: 10px;
                "
                @click="delFunction(index)"
            ></i>
          </el-col>
        </el-row>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item label="通讯协议" prop="CommProtocolIDs">
            <el-select
              v-model="item.CommProtocolIDs"
              multiple
              filterable
              allow-create
              style="width: 100%"
              placeholder="请选择通讯协议"
              :currentList="currentCommProtocolIDs"
            >
              <el-option
                v-for="obj in commProtocolnList"
                :label="obj.Name"
                :value="obj.ID"
                :key="obj.ID"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="启用" prop="StatusInt">
            <el-switch v-model="StatusInt"></el-switch>
          </el-form-item>
          <!-- <el-form-item label="状态" prop="Status">
            <el-select
              v-model="item.Status"
              placeholder="请选择状态"
              style="width: 100%"
            >
              <el-option label="运行" :value="1"></el-option>
              <el-option label="停运" :value="2"></el-option>
            </el-select>
          </el-form-item> -->
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="最低 .NET版本" prop="MiniNetID">
            <select2
              style="width: 100%"
              v-model="item.MiniNetID"
              url="basic?type=NetFW"
              :clearable="false"
              placeholder="最低.Net FW版本"
              noDataText="无"
              :emptyValue="0"
              :queryOne="false"
              :disabled="isEdit"
              :currentList="currentMiniNetID"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="最低操作系统" prop="MiniSystemID">
            <select2
              style="width: 100%"
              v-model="item.MiniSystemID"
              url="basic?type=OS"
              :clearable="false"
              placeholder="请选择最低操作系统"
              noDataText="无"
              :emptyValue="0"
              :queryOne="false"
              :disabled="isEdit"
              :currentList="currentMiniSystemID"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="更新日志" prop="UpdateLog">
        <mavon-editor
          ref="md"
          v-model="item.UpdateLog"
          :toolbars="toolbars"
          :box-shadow="true"
        />
      </el-form-item>
      <el-form-item label="主程序" prop="file">
        <div v-if="isPackShow">
          <el-upload
            ref="uploadPack"
            action=""
            accept=".zip"
            :multiple="false"
            :limit="1"
            :http-request="httpPackRequest"
            :headers="uploadHeader"
            :on-remove="handlePackRemove"
            :on-error="handleError"
          >
            <el-button size="small" type="primary">选择文件</el-button>
          </el-upload>
        </div>
        <div v-else>
          <a
            target="_blank"
            :href="item.Url"
            :download="packName"
            style="color: #409eff"
            >{{ packName }}</a
          >
        </div>
      </el-form-item>
      <el-form-item label="驱动库" prop="drive">
        <div v-if="isDriveShow">
          <el-upload
            ref="uploadDrive"
            action=""
            accept=".zip"
            :multiple="false"
            :limit="1"
            :http-request="httpDriveRequest"
            :headers="uploadHeader"
            :on-remove="handleDriveRemove"
            :on-error="handleError"
          >
            <el-button size="small" type="primary">选择文件</el-button>
          </el-upload>
        </div>
        <div v-else>
          <a
            target="_blank"
            :href="item.DriveUrl"
            :download="driveName"
            style="color: #409eff"
            >{{ driveName }}</a
          >
        </div>
      </el-form-item>
      <el-form-item label="初始化向导" prop="guide">
        <div v-if="isGuideShow">
          <el-upload
            ref="uploadGuide"
            action=""
            accept=".zip"
            :multiple="false"
            :limit="1"
            :http-request="httpGuideRequest"
            :headers="uploadHeader"
            :on-remove="handleGuideRemove"
            :on-error="handleError"
          >
            <el-button size="small" type="primary">选择文件</el-button>
          </el-upload>
        </div>
        <div v-else>
          <a
            target="_blank"
            :href="item.InitialWizardUrl"
            :download="guideName"
            style="color: #409eff"
            >{{ guideName }}</a
          >
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="onClose">
        <i class="fas fa-times"></i> 取 消
      </el-button>
      <el-button type="primary" @click="onSubmit" :disabled="submitting">
        <i class="far fa-save"></i> 确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    value: Object,
    visible: Boolean,
  },
  data() {
    const validateVer = (rule, value, callback) => {
      if (
        value &&
        !value.match(/^[0-9]{1,5}\.[0-9]{1,5}\.[0-9]{1,5}\.[0-9]{1,5}$/)
      ) {
        callback(new Error("请输入正确的版本号,格式：x.x.x.x"));
      } else {
        callback();
      }
    };
    const validateFunctionName = (rule, value, callback) => {
      const arr = rule.fullField.split('.');
      let functionName = '';
      if (arr.length === 3) {
        const index = arr[1];
        functionName = this.item.VersionFunctions[index].Name;
      }
      if (!functionName) {
        const msg = "功能版本名称不能为空";
        callback(new Error(msg));
      } else {
        const sameArr = [];
        let haveSame = false;
        this.item.VersionFunctions.forEach((item, index) => {
          if (!haveSame) {
            sameArr.forEach((name, index) => {
              if (name == item.Name) {
                haveSame = true;
              }
            });
          }
          sameArr.push(item.Name);
        });
        if (haveSame) {
          callback(new Error("功能版本名称重复"));
          return;
        }
        callback();
      }
    };
    const validateFunctionCode = (rule, value, callback) => {
      const arr = rule.fullField.split('.');
      let functionCode = '';
      if (arr.length === 3) {
        const index = arr[1];
        functionCode = this.item.VersionFunctions[index].SpeNb;
      }
      if (!functionCode) {
        const msg = "功能版本编码不能为空";
        callback(new Error(msg));
      } else {
        if (!value.match(/^[0-9]*$/)) {
          callback(new Error("必须00~99之间并且两位数"));
        } else {
          const sameArr = [];
          let haveSame = false;
          this.item.VersionFunctions.forEach((item, index) => {
            if (!haveSame) {
              sameArr.forEach((spenb, index) => {
                if (spenb == item.SpeNb) {
                  haveSame = true;
                }
              });
            }
            sameArr.push(item.SpeNb);
          });
          if (haveSame) {
            callback(new Error("功能版本编号重复"));
            return;
          }
          callback();
        }
      }
    };
    return {
      uploadHeader: {
        Authorization: `Bearer ${window.localStorage.getItem("jwtToken")}`,
        Accept: "application/json",
      },
      // log: "",
      item: {},
      rules: {
        Version: [
          { required: true, message: "版本号不能为空", trigger: "blur" },
          { validator: validateVer, trigger: "blur" },
        ],
        FunctionName: [
          { validator: validateFunctionName, trigger: "blur" },
        ],
        FunctionCode: [
          { validator: validateFunctionCode, trigger: "blur" },
        ],
        CommProtocolIDs: [
          { required: true, message: "通讯协议不能为空", trigger: "blur" },
        ],
        // Status: [
        //   { required: true, message: "状态不能为空", trigger: "blur" },
        // ],
        MiniNetID: [
          { required: true, message: "最低.NetFW不能为空", trigger: "blur" },
        ],
        MiniSystemID: [
          { required: true, message: "最低操作系统不能为空", trigger: "blur" },
        ],
        PublishDay: [
          { required: true, message: "发布日期不能为空", trigger: "blur" },
        ],
      },
      submitting: false,
      toolbars: {
        bold: true, // 粗体
        italic: true, // 斜体
        header: true, // 标题
        underline: true, // 下划线
        strikethrough: true, // 中划线
        mark: true, // 标记
        superscript: true, // 上角标
        subscript: true, // 下角标
        quote: true, // 引用
        ol: true, // 有序列表
        ul: true, // 无序列表
        link: true, // 链接
        // imagelink: true, // 图片链接
        // code: true, // code
        table: true, // 表格
        fullscreen: true, // 全屏编辑
        // readmodel: true, // 沉浸式阅读
        // htmlcode: true, // 展示html源码
        // /* 1.3.5 */
        // undo: true, // 上一步
        // redo: true, // 下一步
        // trash: true, // 清空
        // /* 1.4.2 */
        // navigation: true, // 导航目录
        /* 2.1.8 */
        alignleft: true, // 左对齐
        aligncenter: true, // 居中
        alignright: true, // 右对齐
        /* 2.2.1 */
        subfield: true, // 单双栏模式
        // preview: true, // 预览
      },
      functionList: [],
      commProtocolnList: [],

      isEdit: false, //是否编辑信息
      isPackShow: true, //是否显示上传按钮
      isGuideShow: true,
      isDriveShow: true,
      packName: "", //已上传文件名
      guideName: "",
      driveName: "",
      packList: [], //上传文件数组
      guideList: [],
      driveList: [],
      // currentFunctions: [],
      currentCommProtocolIDs: [],
      currentMiniNetID: [],
      currentMiniSystemID: [],
      isShow: true,
      StatusInt: true, //是否启用
      number: 0,
      pickerOptions: {
        // 只能选择过去的时间
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  methods: {
    onOpen() {
      // this.item.SoftWareID = this.value.ID;
      this.getFunctionList();
      this.getCommProtocolnList();
      if (this.value.ID && this.value.ID !== 0) {
        this.isEdit = true;

        this.$axios
          .get(`software/version/${this.value.ID}`)
          .then((response) => {
            this.item = response.data;
            if (this.item.Url !== "") {
              const strArr = this.item.Url.split("\\");
              this.packName = strArr[strArr.length - 1];
              this.isPackShow = false;
            }
            if (this.item.InitialWizardUrl !== "") {
              const strArr = this.item.InitialWizardUrl.split("\\");
              this.guideName = strArr[strArr.length - 1];
              this.isGuideShow = false;
            }
            if (this.item.DriveUrl !== "") {
              const strArr = this.item.DriveUrl.split("\\");
              this.driveName = strArr[strArr.length - 1];
              this.isDriveShow = false;
            }
            if (this.item.Status == 2) {
              //停用
              this.StatusInt = false;
            } else {
              this.StatusInt = true;
            }
            // if (this.item.UpdateLog) {
            //   this.log = this.item.UpdateLog;
            // }

            // if (this.item.Basics) {
            //   let arr = [];
            //   for (let i = 0; i < this.item.Basics.length; i++) {
            //     let obj1 = this.item.Basics[i];
            //     arr.push(obj1.ID);
            //     this.currentFunctions.push({
            //       ID: obj1.ID,
            //       Name: obj1.Name,
            //     });
            //   }
            //   this.item.Functions = arr;
            // }

            if (this.item.CommProtocolIDs) {
              for (let i = 0; i < this.item.CommProtocols.length; i++) {
                let obj1 = this.item.CommProtocols[i];
                this.currentCommProtocolIDs.push({
                  ID: obj1.ID,
                  Name: obj1.Name,
                });
              }
            }

            if (this.item.MiniNetID) {
              this.currentMiniNetID = [
                {
                  ID: this.item.MiniNetID,
                  Name: this.item.MiniNet.Name,
                },
              ];
            }

            if (this.item.MiniSystemID) {
              this.currentMiniSystemID = [
                {
                  ID: this.item.MiniSystemID,
                  Name: this.item.MiniSystem.Name,
                },
              ];
            }
          });
      } else {
        this.item = {};
        this.item.SoftWareID = this.value.SoftWareID;
        this.item.Status = 1;
        this.StatusInt = true;
        this.item.VersionFunctions = [];
        this.item.VersionFunctions.push({
          Name: "",
          SpeNb: "",
        });
      }
    },
    getFunctionList() {
      this.$axios.get("basic?type=function").then(
        (resp) => {
          this.functionList = resp.data.data;
        },
        (resp) => {
          this.$sys.alarmResponse(resp);
        }
      );
    },
    getCommProtocolnList() {
      this.$axios.get("basic?type=CommProtocol").then(
        (resp) => {
          this.commProtocolnList = resp.data.data;
        },
        (resp) => {
          this.$sys.alarmResponse(resp);
        }
      );
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("cancel");
      this.$refs.itemform.resetFields();
      this.clear();
    },
    clear() {
      this.submitting = false;
      if (this.$refs.uploadPack) {
        this.$refs.uploadPack.clearFiles();
      }
      if (this.$refs.uploadGuide) {
        this.$refs.uploadGuide.clearFiles();
      }
      if (this.$refs.uploadDrive) {
        this.$refs.uploadDrive.clearFiles();
      }
      this.isEdit = false;
      this.isPackShow = true;
      this.isGuideShow = true;
      this.isDriveShow = true;

      this.packName = "";
      this.guideName = "";
      this.driveName = "";
      this.packList = [];
      this.guideList = [];
      this.driveList = [];
      // this.log = "";
      // this.currentFunctions = [];
      this.currentCommProtocolIDs = [];
      this.currentMiniNetID = [];
      this.currentMiniSystemID = [];
    },
    onSubmit() {
      this.$refs.itemform.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.StatusInt) {
          this.item.Status = 1; //启用
        } else {
          this.item.Status = 2; //停运
        }
        this.submitting = true;
        // this.item.UpdateLog = mavonEditor.markdownIt.render(this.log || "");
        this.$emit("input", this.item);
        const itemData = { ...this.item };
        this.$axios
          .request({
            url: this.item.ID
              ? `software/version/${itemData.ID}`
              : "software/version",
            method: itemData.ID ? "put" : "post",
            data: itemData,
          })
          .then(() => {
            this.$message.success(itemData.ID ? "编辑成功" : "新增成功");
            this.$emit(itemData.ID ? "form:updated" : "form:created", true);
            this.$emit("form:saved", true);
            this.$emit("update:visible", false);
            this.clear();
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
            this.$emit(itemData.ID ? "form:updated" : "form:created", false);
            this.$emit("form:saved", false);
          })
          .finally(() => {
            this.submitting = false;
          });
      });
    },

    httpPackRequest(params) {
      var formData = new FormData();
      formData.append("file", params.file);
      this.$axios
        .post(`software/transfile`, formData)
        .then((response) => {
          this.item.Md5 = response.data.Md5;
          this.item.Path = response.data.Path;
          this.item.Url = response.data.Url;

          this.packList.push({
            uid: params.file.uid,
            url: response.data.Url,
          });
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    handlePackRemove(file) {
      let urls = [];
      this.packList.forEach((obj) => {
        if (file.uid === obj.uid) {
          urls.push(obj.url);
          this.$axios
            .delete("ipc/attachmentDelete", {
              data: { urls: urls },
            })
            .then(() => {
              this.item.Md5 = "";
              this.item.Path = "";
              this.item.Url = "";
            })
            .catch(({ response }) => {
              this.$sys.alarmResponse(response);
            });
        }
      });
    },
    httpGuideRequest(params) {
      var formData = new FormData();
      formData.append("file", params.file);
      this.$axios
        .post(`software/initguidefile`, formData)
        .then((response) => {
          this.item.HasInitialWizard = response.data.HasInitialWizard;
          this.item.InitialWizardMd5 = response.data.InitialWizardMd5;
          this.item.InitialWizardPath = response.data.InitialWizardPath;
          this.item.InitialWizardUrl = response.data.InitialWizardUrl;

          this.guideList.push({
            uid: params.file.uid,
            url: response.data.InitialWizardUrl,
          });
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    handleGuideRemove(file) {
      let urls = [];
      this.guideList.forEach((obj) => {
        if (file.uid === obj.uid) {
          urls.push(obj.url);
          this.$axios
            .delete("ipc/attachmentDelete", {
              data: { urls: urls },
            })
            .then(() => {
              this.item.HasInitialWizard = "";
              this.item.InitialWizardMd5 = "";
              this.item.InitialWizardPath = "";
              this.item.InitialWizardUrl = "";
            })
            .catch(({ response }) => {
              this.$sys.alarmResponse(response);
            });
        }
      });
    },
    httpDriveRequest(params) {
      var formData = new FormData();
      formData.append("file", params.file);
      this.$axios
        .post(`software/drivefile`, formData)
        .then((response) => {
          this.item.DriveMd5 = response.data.DriveMd5;
          this.item.DrivePath = response.data.DrivePath;
          this.item.DriveUrl = response.data.DriveUrl;

          this.driveList.push({
            uid: params.file.uid,
            url: response.data.DriveUrl,
          });
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    handleDriveRemove(file) {
      let urls = [];
      this.driveList.forEach((obj) => {
        if (file.uid === obj.uid) {
          urls.push(obj.url);
          this.$axios
            .delete("ipc/attachmentDelete", {
              data: { urls: urls },
            })
            .then(() => {
              this.item.DriveMd5 = "";
              this.item.DrivePath = "";
              this.item.DriveUrl = "";
            })
            .catch(({ response }) => {
              this.$sys.alarmResponse(response);
            });
        }
      });
    },
    handleError(err) {
      this.$message.error(err.message.substring(1, err.message.length - 2));
    },
    addFunction() {
      this.item.VersionFunctions.push({
        Name: "",
        SpeNb: "",
      });
      this.isShow = false;
      this.number += 1;
      this.isShow = true;
    },
    delFunction(index) {
      this.item.VersionFunctions.splice(index, 1);

      this.isShow = false;
      this.number += 1;
      this.isShow = true;
    },
    change() {
      this.$forceUpdate();
    },
  },
};
</script>
